import { useEffect, useState } from "react";
import { toast } from "sonner";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { api, errMsg } from "@/lib/api";
import { fmtDate } from "@/lib/format";

const send = (src, confirm) => {
  if (src.bid) return api.post(`/admin/backups/${src.bid}/restore`, { entry: src.entry, confirm });
  const fd = new FormData();
  fd.append("file", src.file);
  return api.post("/admin/restore", fd, { params: { confirm } });
};

export const RestoreDialog = ({ src, onClose, onRestored }) => {
  const [info, setInfo] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    setInfo(null);
    if (!src) { return; }
    send(src, false).then((r) => setInfo(r.data)).catch((e) => { toast.error(errMsg(e)); onClose(); });
  }, [src, onClose]);

  const restore = async (ev) => {
    ev.preventDefault();
    setBusy(true);
    try {
      const { data } = await send(src, true);
      toast.success(`${data.customer_name} er gjenopprettet`);
      if (data.skipped_users?.length) toast.warning(`Brukere hoppet over (e-post brukes av en annen konto): ${data.skipped_users.join(", ")}`);
      onClose();
      onRestored();
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AlertDialog open={!!info} onOpenChange={(o) => !o && onClose()}>
      <AlertDialogContent data-testid="restore-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>Gjenopprette «{info?.customer_name}»?</AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="space-y-2 text-sm text-slate-600">
              <p data-testid="restore-info">Backup fra {info && fmtDate(info.created_at)}. {info?.exists
                ? "Kunden finnes allerede. Alle nåværende data for kunden (kalkulator, brukere, passasjerrapporter, statistikk og endringslogg) erstattes med innholdet i backupen."
                : "Kunden finnes ikke i dag og blir opprettet på nytt."}</p>
              <p>{info?.counts?.users ?? 0} brukere · {info?.counts?.pax_submissions ?? 0} passasjerrapporter · {info?.counts?.pax_actors ?? 0} rederier</p>
              <p className="font-medium text-red-700">Dette kan ikke angres.</p>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="restore-cancel">Avbryt</AlertDialogCancel>
          <AlertDialogAction onClick={restore} disabled={busy} className="bg-red-700 hover:bg-red-800" data-testid="restore-confirm">
            {busy ? "Gjenoppretter…" : "Gjenopprett"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
